// Role-Based Access Control
// Supports multiple roles per user stored as comma-separated string
// e.g. user_role = "engineer,hr" or user_role = "admin"

// CRM Leads was retired on 29 October 2026 (migration 0417): leads are bids of
// kind 'lead' on the Pipeline Tracker.
const CRM_PAGES = ['crm-dashboard','crm-contacts','bid-tracker','bid-library'];

// My Info was one page with four tabs; it is now four pages under a My Info
// group in the sidebar. They are one record split across four screens rather
// than four separate privileges, so a role holds all four or none, and the old
// 'my-info' key is retired (migration 0336 carries over anything an
// administrator had already granted or denied against it).
const MY_INFO_PAGES = ['my-contact', 'my-leave', 'my-benefits', 'my-allowances'];

// PMO governance view (commercial + delivery oversight) — reused for the new
// commercial-lead approver role and as the basis for partner.
const PMO_PAGES = [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'task-oversight', 'action-oversight', 'dashboard', 'timesheet', 'tracker', 'draft-sows', 'milestones', 'support-sows', 'project-update', 'delivery-cockpit', 'pmo-portfolio', 'plan-portfolio', 'pm-achievements', 'risks', 'change-register', 'pm-allocation', 'repeatable', 'pmo-dashboard', 'delivery-analytics', 'pos', 'inventory', 'hardware-requests', 'org-chart', 'holidays', 'forecast', 'week-planner', 'overtime', 'bookings', 'product-catalog', 'clients', 'plan-templates', 'po-spend', 'ai-usage-report', 'sow-validation', 'sow-reconciliation'];

const PERMISSIONS = {
  admin:      [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'task-oversight', 'action-oversight', 'dashboard', 'tracker', 'draft-sows', 'milestones', 'support-sows', 'project-update', 'delivery-cockpit', 'pmo-portfolio', 'plan-portfolio', 'pm-achievements', 'risks', 'change-register', 'pm-allocation', 'repeatable', 'pmo-dashboard', 'delivery-analytics', 'pos', 'inventory', 'hardware-requests', 'people', 'rate-bands', 'org-chart', 'holidays', 'forecast', 'week-planner', 'budget', 'timesheet', 'payroll', 'profitability', 'executive-summary', 'expected-income', 'remittance', 'po-spend', 'outgoing-invoices', 'audit', 'admin', 'clients', 'overheads', 'rate-cards', 'suppliers', 'product-catalog', 'plan-templates', 'sow-templates', 'ai-knowledge', 'benefits-admin', 'overtime', 'email-inbox', 'onboarding', 'talent-acquisition', 'application-catalogue', 'ecr-tracker', 'bookings', 'm365-licenses', 'resource-workers', 'resource-invoices', 'suggestions-admin', 'delivery-addresses', 'ai-usage-report', 'time-overview', 'sent-emails-audit', 'app-adoption', 'qms-library', 'qms-admin', 'sow-validation', 'sow-reconciliation', 'product-sale-history', 'sage', 'card-spend', 'vat-reclaim', 'sow-legacy-extraction', 'sow-document-duplicates', 'price-book-import', 'leave-import', 'backups', 'service-expiry', 'midwich-price-sync', 'adhoc-purchases-review', 'portal-catalogue', 'client-orders', ...CRM_PAGES],
  partner:    [...PMO_PAGES, 'profitability', 'executive-summary', 'expected-income', 'audit', 'sow-templates', ...CRM_PAGES],
  'commercial-lead': [...PMO_PAGES, 'sow-templates', 'portal-catalogue', ...CRM_PAGES],
  bd:         [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'inventory', 'hardware-requests', 'dashboard', 'timesheet', 'clients', 'bookings', ...CRM_PAGES],
  hr:         [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'inventory', 'hardware-requests', 'task-oversight', 'action-oversight', 'dashboard', 'timesheet', 'payroll', 'people', 'rate-bands', 'org-chart', 'holidays', 'forecast', 'week-planner', 'overtime', 'onboarding', 'talent-acquisition', 'bookings', 'product-catalog', 'resource-workers', 'time-overview', 'qms-admin'],
  pm:         [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'task-oversight', 'action-oversight', 'dashboard', 'timesheet', 'tracker', 'draft-sows', 'milestones', 'support-sows', 'project-update', 'delivery-cockpit', 'pmo-portfolio', 'plan-portfolio', 'pm-achievements', 'risks', 'change-register', 'ecr-tracker', 'pm-allocation', 'repeatable', 'pmo-dashboard', 'delivery-analytics', 'pos', 'inventory', 'hardware-requests', 'org-chart', 'holidays', 'forecast', 'week-planner', 'overtime', 'bookings', 'product-catalog', 'clients', 'plan-templates', 'time-overview', ...CRM_PAGES],
  pmo:        [...PMO_PAGES, 'time-overview', 'qms-admin', 'suggestions-admin', 'delivery-addresses', 'service-expiry', 'adhoc-purchases-review', 'client-orders'],
  finance:    ['sage', 'card-spend', 'vat-reclaim', ...MY_INFO_PAGES, 'my-tasks', 'my-time', 'inventory', 'hardware-requests', 'dashboard', 'timesheet', 'payroll', 'budget', 'overheads', 'profitability', 'executive-summary', 'expected-income', 'remittance', 'po-spend', 'outgoing-invoices', 'bookings', 'email-inbox', 'product-catalog', 'resource-invoices', 'support-sows', 'qms-admin'],
  billing:    ['sage', 'card-spend', 'vat-reclaim', ...MY_INFO_PAGES, 'my-tasks', 'my-time', 'dashboard', 'timesheet', 'payroll', 'tracker', 'draft-sows', 'milestones', 'support-sows', 'pos', 'inventory', 'hardware-requests', 'suppliers', 'profitability', 'expected-income', 'remittance', 'budget', 'po-spend', 'outgoing-invoices', 'bookings', 'email-inbox', 'product-catalog', 'clients', 'resource-invoices', 'service-expiry'],
  engineer:   [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'inventory', 'hardware-requests', 'dashboard', 'timesheet', 'holidays', 'org-chart', 'week-planner', 'bookings', 'product-catalog'],
  contractor: [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'inventory', 'hardware-requests', 'org-chart', 'holidays'],
  'inventory-manager': ['dashboard', 'inventory', 'hardware-requests', 'product-catalog', 'pos'],
  'qms_manager':       [...MY_INFO_PAGES, 'my-tasks', 'my-time', 'dashboard', 'qms-admin'],
  client:     ['client-portal'],
};

// Letting somebody into the app at all: the queue of people who signed in with
// Microsoft and have no account here yet. Admin and HR by default, because they
// are who creates staff on the People page in the first place, but it is a page
// like any other, so it can be granted to another role in Roles & Permissions
// without a deploy and the server reads the same grant.
for (const role of ['admin', 'hr']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('access-requests')) {
    PERMISSIONS[role].push('access-requests');
  }
}

// PLOW (Plan of the Week) — the weekly assignment boards. Managers plan them,
// engineers live on them; everyone else (HR, finance) is a grant away.
for (const role of ['admin', 'pm', 'pmo', 'engineer']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('plow')) {
    PERMISSIONS[role].push('plow');
  }
}

// Desk bookings (My Space) are available to every internal user.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('my-bookings')) {
    PERMISSIONS[role].push('my-bookings');
  }
}

// My Company Card — every internal user, for the same reason as bookings: anybody may hold
// a company card, and the receipt on it is theirs to upload and nobody else's. The page
// only ever shows the signed-in person's own transactions; the server scopes it, not the
// screen.
//
// GRANTED THE SAME WAY BOOKINGS IS, and that matters. The first attempt used a guard in
// canAccess reading `!roles.includes('client')`, which looked equivalent and was not:
// several real people hold an internal role AND 'client' (admin,hr,pm,billing,client,…),
// so the guard never fired for them and the page was in nobody's permission list. It
// simply did not appear, for exactly the people most likely to be looking for it. Pushing
// it into every non-client role is the mechanism that already works.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('my-card-spend')) {
    PERMISSIONS[role].push('my-card-spend');
  }
}

// Holidays & Absence — the role grant is held by every internal role, because
// being a line manager is not a role: an engineer with two reports approves
// their leave on this page and a PMO lead with none has nothing to do there.
// Granting the page role by role (as it once was) left finance, billing and BD
// managers unable to reach their own team's requests. Whether a particular
// person sees it is decided by canSeeHolidays below, on top of this grant, so
// Roles & Permissions can still take the page off a role entirely.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('holidays')) {
    PERMISSIONS[role].push('holidays');
  }
}

// Leave Calendar — every internal user (El's item 29: "Calendar should be
// viewable by all staff"). Who is off this week is not sensitive information
// and is exactly what people need before booking their own leave or a meeting.
// It shows approved leave with no reasons, which is what makes it safe to open
// up; the requests behind it are on the managers' page above.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('leave-calendar')) {
    PERMISSIONS[role].push('leave-calendar');
  }
}

// Approvals — the shell, not the contents.
//
// The page holds one tab per kind of thing waiting on somebody, and each tab
// asks its own question: leave is the line-manager test, overtime is the
// `overtime` grant below, hiring is whether anything is named to this person.
// The shell itself decides nothing, so every internal role may open it and
// sees only what they hold. Somebody with no tabs is told there is nothing
// waiting, and the menu does not offer it to them at all.
//
// Taking `overtime` off a role in Roles & Permissions still removes that tab,
// which is the point: the grant remains the authority.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('approvals')) {
    PERMISSIONS[role].push('approvals');
  }
}

// Quality Docs — the policy library. Every internal user reads it: a policy
// nobody can open cannot be acknowledged, and the compliance matrix expects
// everyone to acknowledge. Granted the same way bookings and holidays are, for
// the reason given above. Administering the library is `qms-admin`, held by the
// roles that list it explicitly.
for (const role of Object.keys(PERMISSIONS)) {
  if (role !== 'client' && !PERMISSIONS[role].includes('qms-library')) {
    PERMISSIONS[role].push('qms-library');
  }
}

// Floor plan display — the full-screen "who is at which desk" board for a tablet at
// the office entrance. Admin and HR hold it by default; a kiosk sign-in gets it as
// the one page granted to its role in Roles & Permissions.
for (const role of ['admin', 'hr']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('floor-plan-display')) {
    PERMISSIONS[role].push('floor-plan-display');
  }
}

// Hours Analysis — managers / finance / HR / admin can analyse logged hours
// org-wide. The server serves the hours and rates to holders of
// time:see-others, seeded (migration 0357) to this same role set.
for (const role of ['admin', 'finance', 'pm', 'pmo', 'hr']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('hours-analysis')) {
    PERMISSIONS[role].push('hours-analysis');
  }
}

// Time Entry Audit — why logged time is not costing against SOW milestones:
// every entry with its route, milestone and rate, and the gaps per SOW. The
// server gates GET /time-entry-audit on this same page grant, so ticking the
// page for another role in Roles & Permissions is enough.
for (const role of ['admin', 'pmo', 'finance', 'hr']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('time-entry-audit')) {
    PERMISSIONS[role].push('time-entry-audit');
  }
}

// Overtime ledger — overtime derived from the time log, with claims and
// costs, for finance, HR and admin. The server gates GET /overtime-ledger on
// this same page grant, so ticking the page for another role is enough.
for (const role of ['admin', 'finance', 'hr']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('overtime-ledger')) {
    PERMISSIONS[role].push('overtime-ledger');
  }
}

// Project cost forecast — typing the cost to complete into the SOW Costs tab.
// PMO and PMs hold it by default; the server gates the milestone cost fields on
// this same grant (plus the SOW's owner and delivery owner), so ticking the page
// for another role in Roles & Permissions is enough.
for (const role of ['admin', 'pmo', 'pm']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('sow-cost-forecast')) {
    PERMISSIONS[role].push('sow-cost-forecast');
  }
}

// Contractor dashboard — finance/billing + contractor managers (server enforces
// the same set on GET /resource-dashboard).
for (const role of ['admin', 'hr', 'finance', 'billing', 'pmo', 'commercial-lead']) {
  if (PERMISSIONS[role] && !PERMISSIONS[role].includes('contractor-dashboard')) {
    PERMISSIONS[role].push('contractor-dashboard');
  }
}

// ── Module → pages map ────────────────────────────────────────────────────────
// Mirrors the navigation sections. Used for module-level access control: when a
// module is locked (admin toggle), its pages show a "coming soon" gate while the
// menu item stays visible. Keys match app_modules.id in the database.
const MODULE_PAGES = {
  'business-dev': CRM_PAGES,
  'commercial':   ['tracker', 'draft-sows', 'milestones', 'support-sows', 'service-expiry', 'sow-reconciliation', 'portal-catalogue', 'sow:send-issued', 'sow:complete', 'sow:edit', 'sow:edit-milestones', 'sow:close-draft', 'sow:delete', 'sow:see-financials', 'sow:coupa-approved'],
  'delivery':     ['pmo-dashboard', 'delivery-analytics', 'pmo-portfolio', 'plan-portfolio', 'pm-achievements', 'delivery-cockpit', 'project-update', 'risks', 'slt-register', 'slt-register:hr', 'change-register', 'pm-allocation', 'plan-templates', 'forecast', 'week-planner', 'plow', 'repeatable', 'ecr-tracker', 'surveys', 'surveys:review', 'application-catalogue', 'sow-cost-forecast'],
  'procurement':  ['pos', 'inventory', 'inventory:manage', 'hardware-requests', 'hardware-requests:review', 'hardware-requests:delete', 'suppliers', 'delivery-addresses', 'adhoc-purchases-review', 'client-orders'],
  'hardware':     ['product-catalog', 'trade-cost:see', 'product-notes:write', 'laptops'],
  'people':       ['dashboard', ...MY_INFO_PAGES, 'my-tasks', 'my-time', 'my-list', 'task-oversight', 'action-oversight', 'people', 'rate-bands', 'clearance-renewals', 'people-plan', 'people-plan:slt', 'org-chart', 'holidays', 'holidays:approve', 'holidays:amend', 'holidays:record-absence', 'holidays:leave-year', 'holidays:company-holidays', 'leave-calendar', 'overtime', 'overtime:approve', 'overtime:delete', 'onboarding', 'talent-acquisition', 'talent-acquisition:see-salary', 'talent-acquisition:manage', 'talent-acquisition:delete', 'hiring:approve-vacancy', 'hiring:approve-offer', 'bookings', 'my-bookings', 'floor-plan-display', 'resource-workers', 'contractor-dashboard', 'time-overview', 'hours-analysis', 'time:see-others', 'time:manage', 'time-entry-audit'],
  'finance':      ['card-spend', 'card-spend:no-receipt-actions', 'timesheet', 'payroll', 'payroll:overtime', 'payroll:overtime-rate', 'overtime-ledger', 'overtime-ledger:claim-for-others', 'email-inbox', 'profitability', 'executive-summary', 'expected-income', 'remittance', 'po-spend', 'outgoing-invoices', 'resource-invoices', 'audit'],
  // The API's resource guards (src/api/routes/index.js): holding one of these
  // keys is what the old AUTHZ_RULES role lists used to decide. Shown in the
  // Access matrix so an administrator can widen or narrow them without a deploy.
  'api':          ['import:use', 'audit:use', 'app-settings:use', 'access-grants:use', 'ai-usage:use', 'sow-approval-bands:write', 'role-definitions:write', 'app-modules:write', 'service-expiry:write', 'service-renewals:write', 'midwich:use', 'distributors:write', 'portal-products:write', 'client-orders:write', 'client-portal-access:use', 'sage:use'],
  'admin':        ['admin', 'access', 'teams:manage-membership', 'sow-templates', 'clients', 'repeatable', 'benefits-admin', 'overheads', 'rate-cards', 'm365-licenses', 'ai-usage-report', 'ai-knowledge', 'app-adoption', 'product-sale-history', 'sow-legacy-extraction', 'sow-document-duplicates', 'backups'],
};

// Pages that must stay available even when their module is locked (core/landing).
// 'interview-feedback' is where an interview panel member records their
// recommendation; being on the panel is the access, so it needs no grant and
// must not be hidden behind the People module lock.
const ALWAYS_ON_PAGES = new Set(['dashboard', ...MY_INFO_PAGES, 'my-tasks', 'my-time', 'my-list', 'inventory', 'hardware-requests', 'sow-detail', 'sow-overview', 'my-sows', 'scan', 'my-bookings', 'my-card-spend', 'client-portal', 'interview-feedback']);

// An action key (page:action) lives under a page and can only be held once
// the page is. The Access screen indents actions under their page and refuses
// to tick one whose page is not ticked. The overtime and holidays keys
// (phase 4) are what src/api/routes/overtime.js and src/api/routes/leave.js
// ask in place of the role checks they used to make, and the hardware-requests
// keys what src/api/routes/hardwareRequests.js asks. The talent keys are what
// src/api/talent.js asks in place of "is this HR or admin". The rates keys
// that do not hang off a page (time:see-others, time:manage, trade-cost:see)
// govern data served by several screens, so none of those screens is the page
// to hold first: finance reads everyone's hours without Hours Overview, and bd
// staff price hardware without the Product Catalog. Keys in src/api/ratesAccess.js.
// The hiring approval keys (hiring:approve-vacancy, hiring:approve-offer) hang
// off no page either: approvers decide on the Hiring tab of Approvals, which
// every internal role holds, and need nothing from Talent Acquisition itself.
// product-notes:write (src/api/routes/productNotes.js) hangs off no page as
// well: the PMO logs a supply note from a request they are reviewing on HW
// Requests as often as from the Product Catalog.
const ACTION_PAGE = {
  'teams:manage-membership': 'access',
  'holidays:approve': 'holidays',
  'holidays:amend': 'holidays',
  'holidays:record-absence': 'holidays',
  'holidays:leave-year': 'holidays',
  'holidays:company-holidays': 'holidays',
  'overtime:approve': 'overtime',
  'overtime:delete': 'overtime',
  'payroll:overtime': 'payroll',
  'payroll:overtime-rate': 'payroll',
  'overtime-ledger:claim-for-others': 'overtime-ledger',
  'hardware-requests:review': 'hardware-requests',
  'hardware-requests:delete': 'hardware-requests',
  // Adding, editing and adjusting stock (pen test AD25996, finding AD16).
  // Scanning and moving it is the Inventory page; src/api/inventoryAccess.js.
  'inventory:manage': 'inventory',
  'talent-acquisition:see-salary': 'talent-acquisition',
  'talent-acquisition:manage': 'talent-acquisition',
  'talent-acquisition:delete': 'talent-acquisition',
  'slt-register:hr': 'slt-register',
  'people-plan:slt': 'people-plan',
  'surveys:review': 'surveys',
  'card-spend:no-receipt-actions': 'card-spend',
};

// SOW issue approval (phase 4, option B): one key per value band, so a team,
// role or person can be given "may approve issuance of SOWs in this band" in
// Admin → Access. Bands are rows an administrator adds, so their keys are not
// listed in MODULE_PAGES: the Access screen adds one row per band from the
// overview, and src/api/routes/sowIssue.js asks the same key. Neither band keys
// nor sow:send-issued sit under a page: the SOW screens they act on are open to
// everybody (sow-detail is always on), so there is no page to hold first. The
// same goes for the SOW write keys (sow:edit, sow:edit-milestones,
// sow:close-draft, sow:delete) that src/api/routes/sows.js asks, and for
// sow:see-financials, without which every SOW still opens but with its values,
// rates, costs and contractor pay taken out on the server (src/api/sowMoney.js).
// sow:coupa-approved, recording the date a client approved a milestone's
// invoice on Coupa, is the same (src/lib/coupaChaseActions.js).
export const SOW_BAND_KEY_PREFIX = 'sow:approve-band:';
export const sowBandKey = (bandId) => `${SOW_BAND_KEY_PREFIX}${bandId}`;
export const sowBandLabel = (band) =>
  `Approve SOW issue: ${band.label || band.id} (£${Number(band.min_value || 0).toLocaleString('en-GB')} and above)`;

const PAGE_TO_MODULE = {};
for (const [mod, pages] of Object.entries(MODULE_PAGES)) {
  for (const p of pages) if (!(p in PAGE_TO_MODULE)) PAGE_TO_MODULE[p] = mod;
}

// Human-readable labels for pages (used in the Admin role-definitions viewer).
const PAGE_LABELS = {
  // Not a screen of its own: it is the panel on the People page listing people
  // who signed in and have no account here yet. It is a page key so that
  // Roles & Permissions is the control surface for who may let somebody in.
  'access-requests': 'Access requests',
  'crm-dashboard': 'Dashboard', 'crm-contacts': 'Contacts', 'bid-tracker': 'Pipeline Tracker', 'bid-library': 'Content Library',
  'dashboard': 'My Dashboard', 'tracker': 'Opportunity Tracker', 'draft-sows': 'Draft SOWs', 'milestones': 'Milestones', 'support-sows': 'Support SOWs', 'sow-reconciliation': 'Remaining Reconciliation', 'sow:send-issued': 'Send an issued SOW to the client', 'sow:complete': 'Mark a SOW Complete by hand', 'sow:edit': 'Create and edit SOWs: details, plan, lines, documents and change notes', 'sow:edit-milestones': 'Add, split and delete milestones, and move a baseline date', 'sow:close-draft': 'Close a draft SOW without the approval workflow', 'sow:delete': 'Delete a SOW outright', 'sow:see-financials': 'See SOW values, rates, costs and contractor pay', 'sow:coupa-approved': 'Record when a milestone invoice is approved on Coupa',
  'pmo-dashboard': 'PMO Dashboard', 'delivery-analytics': 'Delivery Analytics', 'pmo-portfolio': 'Portfolio', 'plan-portfolio': 'Plan Portfolio', 'pm-achievements': 'Achievements', 'delivery-cockpit': 'Delivery Cockpit', 'project-update': 'Project Update', 'risks': 'RAID Register', 'slt-register': 'SLT Register', 'slt-register:hr': 'See and raise HR confidential items (admin alone does not open this)', 'change-register': 'Change Register', 'pm-allocation': 'PM Allocation', 'plan-templates': 'Plan Templates', 'forecast': 'Resource Management', 'week-planner': 'Planner', 'plow': 'PLOW', 'repeatable': 'Repeatable Tasks', 'service-expiry': 'Service Renewals', 'application-catalogue': 'Application Catalogue', 'ecr-tracker': 'ECR Tracker', 'surveys': 'Surveys', 'surveys:review': 'Review surveys, send one back and reopen one', 'sow-cost-forecast': 'Project Cost Forecast',
  'pos': 'Purchase Orders', 'inventory': 'Inventory', 'inventory:manage': 'Manage stock: add and edit items, adjust levels, locations and stock takes', 'hardware-requests': 'HW Requests', 'hardware-requests:review': 'Review, approve and progress any request', 'hardware-requests:delete': 'Delete any request', 'suppliers': 'Suppliers', 'product-catalog': 'Product Catalog', 'trade-cost:see': 'See supplier and trade cost', 'product-notes:write': 'Log and withdraw supply notes on catalogue products', 'adhoc-purchases-review': 'Ad-hoc Purchases', 'client-orders': 'Client Orders', 'portal-catalogue': 'Portal Catalogue',
  'my-contact': 'My Contact Details', 'my-leave': 'My Leave & Holidays', 'my-benefits': 'My Benefits', 'my-allowances': 'My Overtime',
  'my-tasks': 'My Actions', 'my-time': 'My Time', 'my-list': 'My List', 'task-oversight': 'Task Oversight', 'action-oversight': 'Action Oversight', 'people': 'People', 'rate-bands': 'Rate Bands', 'clearance-renewals': 'Clearance & RDN Renewals', 'laptops': 'Laptops', 'people-plan': 'People & Compliance Plan', 'people-plan:slt': 'See and add restricted items (pay, bonus, org chart, succession)', 'org-chart': 'Org Chart', 'approvals': 'Approvals', 'holidays': 'Holiday & Absence Requests', 'holidays:approve': 'See every request and decide any of them', 'holidays:amend': 'Amend a request', 'holidays:record-absence': 'Record an absence for anybody', 'holidays:leave-year': 'Run leave year maintenance', 'holidays:company-holidays': 'Set company holidays', 'leave-calendar': 'Leave Calendar', 'overtime': 'Approval Requests', 'overtime:approve': 'See and decide every claim', 'overtime:delete': 'Delete a claim', 'onboarding': 'Onboarding', 'talent-acquisition': 'Talent Acquisition', 'talent-acquisition:see-salary': 'See salaries on vacancies, candidates and offers', 'talent-acquisition:manage': 'Run hiring: every vacancy, offers, reports and retention', 'talent-acquisition:delete': 'Permanently delete a candidate (GDPR erasure)', 'hiring:approve-vacancy': 'Approve vacancies and requests to reopen them', 'hiring:approve-offer': 'Approve offers above the salary or day-rate band', 'bookings': 'Desk & Van Management', 'my-bookings': 'Desk & Van Bookings', 'floor-plan-display': 'Floor Plan Display', 'resource-workers': 'Manage contractors: records, contracts and approvers (Contractor Dashboard)', 'contractor-dashboard': 'Contractor Dashboard', 'time-overview': 'Hours Overview', 'time:see-others': "See everyone's hours and rates", 'time:manage': "Edit anyone's time", 'time-entry-audit': 'Time Entry Audit',
  'card-spend': 'Company Cards', 'card-spend:no-receipt-actions': 'Given an Action when a cardholder says there is no receipt (admin alone does not)', 'timesheet': 'Timesheet', 'payroll': 'Payroll Export', 'payroll:overtime': 'Overtime pay report and export', 'payroll:overtime-rate': 'Change the rate on an approved claim', 'overtime-ledger': 'Overtime', 'overtime-ledger:claim-for-others': 'Claim or dismiss for somebody else', 'email-inbox': 'Accounts Inbox', 'profitability': 'Profitability', 'executive-summary': 'Executive Summary', 'expected-income': 'Expected Income', 'remittance': 'Remittance', 'po-spend': 'PO Spend', 'outgoing-invoices': 'Outgoing Payments', 'resource-invoices': 'Ext. Resource Invoices', 'audit': 'Audit Trail', 'budget': 'Budget',
  'import:use': 'Data import (API)', 'audit:use': 'Audit trail (API)', 'app-settings:use': 'App settings (API)', 'access-grants:use': 'Access grants (API)', 'ai-usage:use': 'AI usage (API)', 'sow-approval-bands:write': 'Edit SOW approval bands', 'role-definitions:write': 'Edit role definitions', 'app-modules:write': 'Edit module locks', 'service-expiry:write': 'Edit service renewals', 'service-renewals:write': 'Edit service renewal records', 'midwich:use': 'Midwich admin (API)', 'distributors:write': 'Edit distributor settings', 'portal-products:write': 'Curate the portal catalogue', 'client-orders:write': 'Action client orders', 'client-portal-access:use': 'Client portal access (API)', 'sage:use': 'Sage (API)',
  'admin': 'Settings', 'access': 'Access', 'teams:manage-membership': 'Manage team membership', 'sow-templates': 'SOW Templates', 'clients': 'Clients', 'benefits-admin': 'Benefits', 'overheads': 'Overheads', 'rate-cards': 'Rate Cards', 'm365-licenses': 'M365 Licenses', 'delivery-addresses': 'Delivery Addresses', 'suggestions-admin': 'Suggestions', 'data-import': 'Data Import', 'ai-usage-report': 'AI Usage Report', 'ai-knowledge': 'AI Knowledge', 'app-adoption': 'App Adoption', 'sow-document-backfill': 'SOW Document Backfill', 'zoho-cutover-import': 'Zoho Cutover Import', 'price-book-import': 'Price Book Cutover', 'leave-import': 'Leave Import', 'midwich-price-sync': 'Midwich Price Sync', 'product-sale-history': 'Product Sale History', 'sow-legacy-extraction': 'SOW Legacy Extraction', 'sow-document-duplicates': 'SOW Doc Duplicates', 'backups': 'Backups',
};

// ── Access is a set of grants held by principals ─────────────────────────────
//
// A principal is a team ('team:<id>'), a role ('role:<key>') or the person
// themselves ('person:<id>'). The access_grants table says which pages each
// principal holds, and somebody reaches a page when any principal of theirs
// holds it. PERMISSIONS above is the seed that migration 0350 wrote into that
// table; it is not read at runtime, so a tick in Admin → Access is the decision
// and nothing in code can overrule it.
//
// Two things stay in code because they must hold even on an empty table: admin
// is every page, and the client portal role is the portal.

/** Turn access_grants rows into `{ 'type:key': Set<page> }`. Shared with the Worker. */
export function indexGrants(rows) {
  const map = {};
  for (const { principal_type, principal_key, page } of (rows || [])) {
    const key = `${principal_type}:${principal_key}`;
    if (!map[key]) map[key] = new Set();
    map[key].add(page);
  }
  return map;
}

/**
 * The principals a person acts as: each of their roles, their primary team
 * (people.team_id), any additional teams handed in (person_teams), and the
 * person themselves for direct grants.
 */
export function principalsFor(user, extraTeamIds = []) {
  if (!user) return [];
  const out = [];
  for (const r of parseRoles(user.user_role)) out.push(`role:${r}`);
  const teams = new Set([user.team_id, ...(extraTeamIds || [])].filter(Boolean));
  for (const t of teams) out.push(`team:${t}`);
  if (user.id) out.push(`person:${user.id}`);
  return out;
}

// The browser's own access: one tab serves one person, so it can hold the
// answer in module state. The API cannot (one isolate serves many people) and
// calls canAccessWith directly with what it loaded for the request.
let _principals = [];
let _grants = {};

export function applyAccess({ principals = [], grants = [] } = {}) {
  _principals = [...(principals || [])];
  _grants = Array.isArray(grants) ? indexGrants(grants) : (grants || {});
}

/** Parse a (possibly comma-separated) role string into an array of role keys */
export function parseRoles(roleString) {
  if (!roleString) return [];
  return roleString.split(',').map(r => r.trim()).filter(Boolean);
}

/**
 * The permission rule itself, as a pure function of what it is handed.
 * `principals` is from principalsFor; `grants` is `{ 'type:key': Set<page> }`
 * from indexGrants.
 */
export function canAccessWith(principals, page, grants = {}) {
  const ps = principals || [];
  if (ps.includes('role:admin')) return true;
  if (page === 'client-portal' && ps.includes('role:client')) return true;
  // Desk/vehicle bookings is a personal My Space page every internal user can
  // reach by being staff at all, whatever the table says. Only the external
  // client portal role is excluded.
  if (page === 'my-bookings' && ps.some(p => p.startsWith('role:') && p !== 'role:client')) return true;
  return ps.some(p => grants[p]?.has(page));
}

/**
 * Server-side convenience: does `user` hold `page` given `access` from
 * loadAccess ({ principals, grants })? Falls back to the user's roles alone
 * when no access object is handed in, which is enough for admin.
 */
export function holdsPage(user, page, access = {}) {
  return canAccessWith(access.principals ?? principalsFor(user), page, access.grants ?? {});
}

/** Browser wrapper: does the signed-in person reach this page? */
export function canAccess(page) {
  return canAccessWith(_principals, page, _grants);
}

/** Browser wrapper: every page the signed-in person reaches. */
export function getPermissions() {
  const all = new Set();
  for (const p of _principals) for (const page of (_grants[p] || [])) all.add(page);
  if (canAccessWith(_principals, 'my-bookings', _grants)) all.add('my-bookings');
  if (canAccessWith(_principals, 'client-portal', _grants)) all.add('client-portal');
  return [...all];
}

export function isAdmin(user) {
  return parseRoles(user?.user_role).includes('admin');
}

// The Holidays page is the approvals and register view: line managers, HR and
// admin. Somebody with nobody reporting to them requests and cancels their own
// leave on My Leave, and item 29's open calendar was closed on 16 September
// 2026. `has_reports` comes from /people/me, counted on the server, so the menu
// and the route read one flag rather than fetching the directory to work it out.
export function canSeeHolidays(user) {
  if (!user) return false;
  const roles = parseRoles(user.user_role);
  if (roles.some(r => r === 'admin' || r === 'hr')) return true;
  return Number(user.has_reports || 0) > 0;
}

export function isManager(user) {
  const roles = parseRoles(user?.user_role);
  return roles.some(r => ['admin', 'pm'].includes(r));
}

/** The module id a page belongs to (or null if it isn't module-gated). */
export function moduleForPage(page) {
  return PAGE_TO_MODULE[page] || null;
}

/**
 * Is `page` locked for `user` given the modules config from /rbac/config?
 * Admins always bypass module locks. Core pages are never locked.
 * `modules` is an array of { id, is_enabled, locked_message }.
 */
export function moduleLockInfo(page, modules, user) {
  if (!page || isAdmin(user)) return null;
  if (ALWAYS_ON_PAGES.has(page)) return null;
  const modId = PAGE_TO_MODULE[page];
  if (!modId) return null;
  const mod = (modules || []).find(m => m.id === modId);
  if (!mod || mod.is_enabled) return null;
  return { id: mod.id, label: mod.label || modId, message: mod.locked_message || '' };
}

export { PERMISSIONS, MODULE_PAGES, PAGE_LABELS, ALWAYS_ON_PAGES, ACTION_PAGE };
